import { AxiosRequestConfig } from 'axios'

export interface GeneralMetricsParams {
  startDate: string
  endDate: string
  // Comma-separated list expected by backend, e.g. "76,77"
  storeIds?: string
}

export interface GeneralMetricsData {
  totalRecords: number
  uniqueUsers: number
  averageFrequency: number
  physicalRecords: number
  deliveryRecords: number
  physicalPercentage: number
  deliveryPercentage: number
}

export interface GeneralMetricsResponse {
  data: GeneralMetricsData
}

const getGeneralMetrics = (params: GeneralMetricsParams): AxiosRequestConfig => ({
  url: '/dashboard/tickets/general-metrics',
  method: 'GET',
  params,
})

export { getGeneralMetrics }
